export enum LOGOUT_REASON {
  INACTIVITY = 'inactivity',
  SESSION_EXPIRED = 'sessionExpired',
}

export const DEFAULT_INACTIVITY_TIMEOUT_MINUTES = 60;
export const DEFAULT_SESSION_RESUME_TIMEOUT_MINUTES = 60;
